import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 32px;
  padding: 0 10px;
  background: #f7f7f7;

  display: flex;
  justify-content: space-between;
  align-items: center;

  position: relative;
`;

export const NavList = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const Tab = styled.div<{ active?: boolean }>`
  font-size: 12px;
  letter-spacing: -0.01em;
  line-height: 16px;
  color: #494949;

  padding: 8px 8px;

  cursor: pointer;

  ${(props) => {
    if (props?.active) {
      return css`
        color: #0046ff;
        font-weight: 500;
        border-bottom: 2px solid #0046ff;
      `;
    }
    return;
  }}
`;
